/** Discriminant strings for `offlineActionQueue` entries (Communicate + future flows). */
export const OFFLINE_ACTION_COMMUNICATE_SERVER_EMAIL = 'communicate_server_email' as const;
export const OFFLINE_ACTION_COMMUNICATE_SERVER_SMS = 'communicate_server_sms' as const;
export const OFFLINE_ACTION_COMMUNICATE_CONTACT_APPEND = 'communicate_contact_log_append' as const;
export const OFFLINE_ACTION_TEACH_BEHAVIOR_SHEET_APPEND = 'teach_behavior_sheet_append' as const;
export const OFFLINE_ACTION_COMMUNICATE_THREAD_SEND = 'communicate_firebase_thread_send' as const;

export type OfflineCommunicateEmailPayload = {
  to: string;
  subject: string;
  text: string;
};

export type OfflineCommunicateSmsPayload = {
  to: string;
  body: string;
};

export type OfflineCommunicateContactAppendPayload = {
  sheetId: string;
  row: {
    student: string;
    parent: string;
    category: string;
    title: string;
    note: string;
    fullMessage: string;
    school: string;
    subject: string;
  };
};

export type OfflineTeachBehaviorSheetPayload = {
  spreadsheetId: string;
  row: {
    courseName: string;
    assignmentTitle: string;
    studentName: string;
    sentiment: string;
  };
};

export type OfflineCommunicateThreadSendPayload = {
  studentName: string;
  courseId: string;
  englishText: string;
  translatedText: string;
  senderName: string;
};
